import { find } from 'lodash';

export const resolveCategories = (page = undefined, perpage = undefined, deleted = undefined) => {
  return [ 'categoriesService', categoriesService => {
    return categoriesService.findAll(page, perpage, deleted).then(list => list);
  }];
};

export const resolveCategoriesEvents = (page = undefined, perpage = undefined, deleted = undefined) => {
  return [ 'categoriesService', categoriesService => {
    return categoriesService.findRelated().then(list => list);
  }];
};

export const resolveNestedCategories = (flatten = null) => {
  return [ 'categoriesService', categoriesService => {
    return categoriesService.hierarchyFind(flatten).then(list => list);
  }];
};

export const resolveCategory = (param = 'category') => {
  return [ '$stateParams', 'categoriesService', ($stateParams, categoriesService) => {
    return $stateParams[param] && $stateParams[param] > 0 ? categoriesService.findById($stateParams[param]) : {};
  }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/resolvers/categories.resolver.js